<template>
  <div class="product">
    <ProductCard v-if="teaser" :rate="rate" title="Healthcare professional" />
    <ProductConfig v-else class="product-config" :rate="rate">
      <div class="container-wrap">
        <AppSelect v-model="form.limit" placeholder="Select amount" @input="handleInput">
          <option v-for="val in limits" :key="val" :value="val">{{ val | currency }}</option>
          <div slot="label">Select your limit for this cover:</div>
        </AppSelect>

        <p>This includes your liability for:</p>
        <p><strong>Medical malpractice</strong></p>
        <p>Bodily injury or death of a patient caused by breach of your professional duties.</p>
        <p><strong>Professional indemnity</strong></p>
        <p>Financial loss caused by any negligent act, error or omission in your professional services.</p>
        <p><strong>Public liability</strong></p>
        <p>Bodily injury or property damage caused by an accident in connection with your business activities.</p>
      </div>
    </ProductConfig>
  </div>
</template>

<script>
import ProductCard from '@/components/products/Card.vue'
import ProductConfig from '@/components/products/Config.vue'
import AppSelect from '@/components/products/form/Select.vue'
import rateMixin from '@/mixins/rate'

export default {
  // filters: {},
  components: {
    ProductCard,
    ProductConfig,
    AppSelect,
  },
  mixins: [rateMixin],
  props: {
    teaser: {
      type: Boolean,
      default: false,
    },
    rate: {
      type: Object,
      required: true,
    },
  },
  data () {
    if (this.teaser) return {}

    const defaultRatingInputs = {
      id: 'HealthcareProfessional',
      key: 'HealthcareProfessional\\HealthcareProfessional',
      active: true,
      limit: null,
      errors: [],
    }

    // overwrite defaults with what ratingEngine returns
    let ratingInputs = { ...defaultRatingInputs, ...this.rate.ratingInputs }

    // if there's a rate passed, overwrite default inputs
    const rate = this.getRate(this.rate.key)
    if (rate) ratingInputs = { ...ratingInputs, ...rate.ratingInputs }

    return {
      productKey: 'HealthcareProfessional',
      loading: false,

      form: {
        ...ratingInputs,
        // can't access this.getters here - need to access directly via $store
        productUuid: this.getAvailableProduct('HealthcareProfessional').id,
        turnover: this.$store.getters.getTurnover,
        isValidBusiness: this.$store.getters.getIsValidBusiness,
        industryId: this.$store.getters.getIndustryId,
        employeeCount: this.$store.getters.getEmployeeCount,
      },
    }
  },
  computed: {
    limits () {
      let result = ['500000', '1000000', '2000000', '3000000', '4000000', '5000000']

      // Custom limits for Urban - @TODO - change this to work off `source`?
      const couponId = this.$store.getters.couponIds
      if (couponId.includes('URBAN1MONTH') || couponId.includes('URBAN10')) {
        result = result.filter(val => val !== '500000')
      }

      return result
    },
  },
  mounted () {
    if (!this.teaser) {
      this.handleSubmit()
    }
  },

  methods: {
    validate () {
      if (!this.form.limit) return false

      return true
    },
    handleSubmit () {
      // reset estimate if it has already been submitted for this rate
      this.$store.commit('updateEstimate', null)

      if (!this.validate()) {
        return
      }

      this.loading = true

      this.updateRate(this.form)
        .then(() => (this.loading = false))
        .catch(() => (this.loading = false))
    },
    handleInput () {
      this.handleSubmit()
    },
  },
}
</script>
